import React from "react";
import UserTable from "./UserTable";
import UserHeader from "./UserHeader";

const Index = ({ 
  arg: {
    logs,
    filteredLogs,
    loading,
    searchData,
    setSearchData,
    handleSearchInput,
    pageC,
    setPageC,
    limit,
    setLimit,
    totalLogs,
    fetchLogs,
    handleRefresh
  }
}) => {
  return (
    <div className="contentclss">
      <UserHeader 
        searchData={searchData}
        setSearchData={setSearchData}
        handleSearchInput={handleSearchInput}
        loading={loading}
        handleRefresh={handleRefresh}
      />
      
      <div className="sub2container">
        <UserTable
          filteredLogs={filteredLogs}
          loading={loading}
          pageC={pageC}
          setPageC={setPageC}
          limit={limit}
          setLimit={setLimit}
          totalLogs={totalLogs}
        />
      </div>
    </div>
  );
};

export default Index;
